import type { WorkSession } from '@/types/workSession.type';
import { TableCell, TableRow } from '../ui/table';
import { WorkSessionActions } from './WorkSessionActions';
import { formatDuration } from '@/lib/date.utils';
import { Badge } from '../ui/badge';
import { formatTimeFr } from '@/lib/formatTimeFr';
import { WorkSessionStatusBadge } from './WorkSessionStatusBadge';
import { isOvernightSession } from '@/lib/workSession.utils';

type WorkSessionRowProps = {
    session: WorkSession;
    onEdit: (session: WorkSession) => void;
    onDelete: (session: WorkSession) => void;
}

const WorkSessionRow = ({session, onEdit, onDelete}: WorkSessionRowProps) => {
    const isOvernight = isOvernightSession(session);
    const startDate = new Date(session.startTime);
    const endDate = session.endTime ? new Date(session.endTime) : null;
    return (
        <TableRow className="transition-colors duration-150 hover:bg-muted/30">
            <TableCell className="py-2 font-mono max-w-[210px]">
                {formatTimeFr(startDate)}
            </TableCell>
            <TableCell className="py-2 font-mono min-w-0 max-w-[210px]">
                <span className="inline-flex flex-wrap items-center gap-1">
                <span>{endDate ? formatTimeFr(endDate) : "-"}</span>
                {isOvernight && (
                    <Badge variant="outline" className="text-xs">
                    +1j
                    </Badge>
                )}
                </span>
            </TableCell>
            <TableCell className="py-2 min-w-0 max-w-[110px]">
                <span className="font-medium">{formatDuration(session.duration || 0)}</span>
            </TableCell>
            <TableCell className="py-2 min-w-0 max-w-[110px]">
                <WorkSessionStatusBadge session={session} />
            </TableCell>
            <TableCell className="py-2 text-right min-w-0 max-w-[220px]">
                <WorkSessionActions
                session={session}
                onEdit={onEdit}
                onDelete={onDelete}
                size="sm"
                />
            </TableCell>
        </TableRow>
        );
};

export default WorkSessionRow;